import { render, staticRenderFns } from "./ClientsEditor.vue?vue&type=template&id=8c8fc69a&scoped=true&"
import script from "./ClientsEditor.vue?vue&type=script&lang=js&"
export * from "./ClientsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8fc69a",
  null
  
)

export default component.exports